export const JOURNEY_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/check-in/journey`;
export const JOURNEY_END_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/check-out/journey`;
export const CHECK_IN_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/check-in/dealer`;
export const CHECK_OUT_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance?check-out/dealer`;
export const DEALER_LIST_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/dealer-list`;
export const LOGOUT_URL =
  "/redirect?redirect_to=https://leadx-new.parkplus.io/login";
export const DARWIN_ATTENDANCE =
  "/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/darwin";
export const APARTMENT_CHECK_IN_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/check-in/apartment`;
export const APARTMENT_CHECK_OUT_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/attendance/check-out/apartment`;
export const OPPORTUNITY_LIST_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/account/opportunity/list`;
export const ACCOUNT_LIST_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/account/list`;
export const TOLL_ACCOUNT_LIST_URL = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/account/tolls/list`;
export const CAR_LOAN_B2B_FLOW = `https://parkplus.io/app/b2b/car-loan`;
export const VALET_ACCOUNT_LIST = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/valet/account-list`;
export const VALET_PROJECT_LIST = `/redirect?redirect_to=https://leadx-new.parkplus.io/app/valet/project-list`;

export const FORCE_UPGRADE_MODULE_TYPES = ["dealer"]

export const isNewLeadX = () => {
  if (!!window.sessionStorage.getItem("isNewleadx")) return true;
  else return false;
};
